export enum C2ATypeEnum {
  StandardButton = "Standard Button",
  DownloadAppButtons = "Download App Buttons",
  SupportButtons = "Support buttons",
  CalendlyWidget = "Calendly Widget (inline)",
  CalendlyPopup = "Calendly Popup",
  ChatButton = "Chat Button",
  IntercomWorkflow = "Intercom Workflow",
}

/** C2A types that render their own widget (chat, Calendly, app-store buttons)
 * instead of navigating. Editors often still fill in a `destination` on these
 * — usually the page the C2A sits on — so callers must key off the type, not
 * off the presence of a destination, or they render a dead button. */
const WIDGET_C2A_TYPES: string[] = [
  C2ATypeEnum.DownloadAppButtons,
  C2ATypeEnum.SupportButtons,
  C2ATypeEnum.CalendlyWidget,
  C2ATypeEnum.CalendlyPopup,
  C2ATypeEnum.ChatButton,
  C2ATypeEnum.IntercomWorkflow,
];

export const isWidgetC2aType = (type: string | null | undefined): boolean =>
  !!type && WIDGET_C2A_TYPES.includes(type);
